"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRunExecutionRefusal = exports.DuplicationItemStatus = exports.DuplicationStatus = exports.RunAnalyticsFilterMode = exports.InputType = exports.RunReportType = exports.RunInstanceIdType = exports.RunType = exports.InitialRunType = exports.canLaunchNewAttempt = exports.LAUNCH_BLOCKING_STATUSES = exports.completedRunStatuses = exports.activeRunStatuses = exports.getRunStatusDisplayText = exports.normalizeRunStatusFilterValue = exports.normalizeRunStatus = exports.ExecutionVisibility = exports.LEGACY_RUN_STATUS_VALUES = exports.RunStatus = void 0;
var RunStatus;
(function (RunStatus) {
    RunStatus["NotSubmitted"] = "NotSubmitted";
    RunStatus["Init"] = "Initializing";
    RunStatus["Waiting"] = "Submitted";
    RunStatus["NextSuccess"] = "Completed";
    RunStatus["Manual"] = "Manual";
    RunStatus["Terminated"] = "Terminated";
    RunStatus["Error"] = "LaunchFailed";
    RunStatus["Aborted"] = "Unreachable";
    RunStatus["NextError"] = "Failed";
    RunStatus["NextRun"] = "Running";
})(RunStatus || (exports.RunStatus = RunStatus = {}));
exports.LEGACY_RUN_STATUS_VALUES = {
    init: RunStatus.Init,
    Waiting: RunStatus.Waiting,
    NextRun: RunStatus.NextRun,
    NextSuc: RunStatus.NextSuccess,
    NextErr: RunStatus.NextError,
    Error: RunStatus.Error,
    Aborted: RunStatus.Aborted,
};
var ExecutionVisibility;
(function (ExecutionVisibility) {
    ExecutionVisibility["Visible"] = "visible";
    ExecutionVisibility["Unreachable"] = "unreachable";
})(ExecutionVisibility || (exports.ExecutionVisibility = ExecutionVisibility = {}));
const CANONICAL_RUN_STATUS_VALUES = new Set(Object.values(RunStatus));
const normalizeRunStatus = (value) => {
    if (CANONICAL_RUN_STATUS_VALUES.has(value))
        return value;
    return exports.LEGACY_RUN_STATUS_VALUES[value];
};
exports.normalizeRunStatus = normalizeRunStatus;
const normalizeRunStatusFilterValue = (value) => {
    var _a;
    const parts = value
        .split("|")
        .map((part) => part.trim())
        .filter(Boolean);
    if (parts.length === 0)
        return value;
    const normalized = [];
    for (const part of parts) {
        const canonical = (_a = (0, exports.normalizeRunStatus)(part)) !== null && _a !== void 0 ? _a : part;
        if (!normalized.includes(canonical))
            normalized.push(canonical);
    }
    return normalized.join("|");
};
exports.normalizeRunStatusFilterValue = normalizeRunStatusFilterValue;
const getRunStatusDisplayText = (value) => {
    const canonical = typeof value === "string" ? (0, exports.normalizeRunStatus)(value) : undefined;
    switch (canonical) {
        case RunStatus.NextError:
        case RunStatus.Error:
            return "Error";
        case RunStatus.NextSuccess:
            return "Completed";
        case RunStatus.NextRun:
            return "Running";
        case RunStatus.Init:
            return "Initializing";
        case RunStatus.Terminated:
            return "Terminated";
        case RunStatus.NotSubmitted:
            return "Not Submitted";
        case RunStatus.Aborted:
            return "Connecting";
        case RunStatus.Waiting:
            return "Initializing";
        default:
            return "Connecting";
    }
};
exports.getRunStatusDisplayText = getRunStatusDisplayText;
exports.activeRunStatuses = [
    RunStatus.Init,
    RunStatus.Waiting,
    RunStatus.NextRun,
    RunStatus.Aborted,
];
exports.completedRunStatuses = [
    RunStatus.NextSuccess,
    RunStatus.Terminated,
    RunStatus.Error,
    RunStatus.NextError,
];
exports.LAUNCH_BLOCKING_STATUSES = [
    RunStatus.Init,
    RunStatus.Waiting,
    RunStatus.NextRun,
];
const canLaunchNewAttempt = (currentStatus) => {
    if (!currentStatus)
        return true;
    const canonical = (0, exports.normalizeRunStatus)(currentStatus);
    if (!canonical)
        return true;
    return !exports.LAUNCH_BLOCKING_STATUSES.includes(canonical);
};
exports.canLaunchNewAttempt = canLaunchNewAttempt;
var InitialRunType;
(function (InitialRunType) {
    InitialRunType["Gzip"] = "gzip";
    InitialRunType["Extracted"] = "extracted";
})(InitialRunType || (exports.InitialRunType = InitialRunType = {}));
var RunType;
(function (RunType) {
    RunType["ReRun"] = "rerun";
    RunType["NewRun"] = "newrun";
    RunType["ResumeRun"] = "resumerun";
})(RunType || (exports.RunType = RunType = {}));
var RunInstanceIdType;
(function (RunInstanceIdType) {
    RunInstanceIdType["Process"] = "process";
    RunInstanceIdType["Pipeline"] = "pipeline";
    RunInstanceIdType["PipelineRev"] = "pipeline_rev";
    RunInstanceIdType["ProcessRev"] = "process_rev";
    RunInstanceIdType["RunLog"] = "run_log";
})(RunInstanceIdType || (exports.RunInstanceIdType = RunInstanceIdType = {}));
var RunReportType;
(function (RunReportType) {
    RunReportType["Html"] = "html";
    RunReportType["Table"] = "table";
    RunReportType["Image"] = "image";
    RunReportType["Pdf"] = "pdf";
})(RunReportType || (exports.RunReportType = RunReportType = {}));
var InputType;
(function (InputType) {
    InputType["Input"] = "input";
    InputType["Collection"] = "collection";
    InputType["VmetaCollection"] = "vmetaCollection";
})(InputType || (exports.InputType = InputType = {}));
var RunAnalyticsFilterMode;
(function (RunAnalyticsFilterMode) {
    RunAnalyticsFilterMode["AllRuns"] = "allRuns";
    RunAnalyticsFilterMode["PipelineName"] = "pipelineName";
    RunAnalyticsFilterMode["PipelineVersion"] = "pipelineVersion";
})(RunAnalyticsFilterMode || (exports.RunAnalyticsFilterMode = RunAnalyticsFilterMode = {}));
var DuplicationStatus;
(function (DuplicationStatus) {
    DuplicationStatus["Pending"] = "pending";
    DuplicationStatus["InProgress"] = "in_progress";
    DuplicationStatus["Completed"] = "completed";
    DuplicationStatus["Failed"] = "failed";
    DuplicationStatus["Cancelled"] = "cancelled";
})(DuplicationStatus || (exports.DuplicationStatus = DuplicationStatus = {}));
var DuplicationItemStatus;
(function (DuplicationItemStatus) {
    DuplicationItemStatus["ItemOk"] = "ok";
    DuplicationItemStatus["ItemPending"] = "pending";
    DuplicationItemStatus["ItemInProgress"] = "in_progress";
    DuplicationItemStatus["ItemFailed"] = "failed";
})(DuplicationItemStatus || (exports.DuplicationItemStatus = DuplicationItemStatus = {}));
const isPlainRecord = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
const parseRunExecutionFallback = (value) => {
    if (!isPlainRecord(value) ||
        value.transport !== "ssh" ||
        !Array.isArray(value.dataSources)) {
        return undefined;
    }
    const dataSources = [];
    for (const entry of value.dataSources) {
        if (!isPlainRecord(entry) ||
            typeof entry.id !== "number" ||
            typeof entry.name !== "string") {
            return undefined;
        }
        dataSources.push({ id: entry.id, name: entry.name });
    }
    return { transport: "ssh", dataSources };
};
const parseRunExecutionRefusal = (status, data) => {
    if (status !== 409 || !isPlainRecord(data))
        return null;
    const { message, reason, remedy } = data;
    if (typeof message !== "string" ||
        typeof reason !== "string" ||
        typeof remedy !== "string") {
        return null;
    }
    const fallback = parseRunExecutionFallback(data.fallback);
    return fallback === undefined
        ? { message, reason, remedy }
        : { message, reason, remedy, fallback };
};
exports.parseRunExecutionRefusal = parseRunExecutionRefusal;
